import {AccountMappingType, ChargeCodeType, ItemType} from "@app/shared";

export class InvoiceImportCCMapping {
  id?: number;
  version?: number;
  uniqueKey: string;
  displayLabel: string;
  orgId: number;
  chargeCodeId: number;
}

export class InvoiceImportDefaultSetting {
  id?: number;
  version?: number;
  catalogId: number;
  catalogName: string;
  unitOfMeasureId: number;
  catalogDescription: string;
  orgId: number;
  adminId: number;
  billToId: number;
  shipToId: number;
  pdfTemplateId: number;
}



export class InvoiceImportItem {
  id?: number;
  version?: number;
  invoiceDate: string;
  expenseMemo: string;
  invoiceNumber: string;
  expenseAccount: string;
  chrgIdentifier: string;
  itemIdentifier: string;
  vendorIdentifier: string;
  expenseAmount: number;
  orgId: number;
}

export class InvoiceImportItemMapping {
  id?: number;
  version?: number;
  codeType: ChargeCodeType;
  itemType: ItemType;
  uniqueKey: string;
  displayLabel: string;
  vendorIdentifier: string;
  expenseAccount: string;
  orgId: number;
  abstractItemId: number;
  ledgerAccountId: number;
  unitOfMeasureId: number;
  accountMappings: InvoiceImportItemLedgerAccountMapping[];
}

export class InvoiceImportItemLedgerAccountMapping {
  id?: number;
  version?: number;
  itemType: ItemType;
  codeType: ChargeCodeType;
  accountMappingType: AccountMappingType;
  itemMappingId: number;
  defaultSettingId: number;
  ledgerAccountId: number;
  orgId: number;
  txnNumber?: string;
}


export class InvoiceImportVendorMapping {
  id?: number;
  version?: number;
  uniqueKey: string;
  displayLabel: string;
  orgId: number;
  vendorId: number;
}
